import { render, staticRenderFns } from "./FilePreviewPDF.vue?vue&type=template&id=4eca3b60&"
import script from "./FilePreviewPDF.vue?vue&type=script&lang=js&"
export * from "./FilePreviewPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports